/**
 * General purpose cookie utility functions
 */

const DEFAULT_MAX_AGE = 30 * 24 * 60 * 60; // 30 days in seconds
const REFERRAL_COOKIE_NAME = 'jumble_referral';

/**
 * Set cookie value with optional expiration
 */
export const setCookie = (name: string, value: string, maxAge: number = DEFAULT_MAX_AGE): void => {
  if (!name?.trim() || !value?.trim()) {
    console.warn('setCookie: Invalid cookie name or value provided');
    return;
  }
  
  document.cookie = `${name.trim()}=${encodeURIComponent(value.trim())}; max-age=${maxAge}; path=/; secure; samesite=strict`;
};

/**
 * Get cookie value by name
 */
export const getCookie = (name: string): string | null => {
  if (!name?.trim()) {
    console.warn('getCookie: Invalid cookie name provided');
    return null;
  }
  
  const cookies = document.cookie.split(';');
  
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=').map(c => c.trim());
    if (cookieName === name.trim()) {
      return cookieValue ? decodeURIComponent(cookieValue) : null;
    }
  }
  
  return null;
};

/**
 * Clear cookie by name
 */
export const clearCookie = (name: string): void => {
  if (!name?.trim()) {
    console.warn('clearCookie: Invalid cookie name provided');
    return;
  }
  
  document.cookie = `${name.trim()}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};

/**
 * Set referral code in cookie with 30-day expiration
 */
export const setReferralCookie = (code: string): void => {
  setCookie(REFERRAL_COOKIE_NAME, code);
};

/**
 * Get referral code from cookie
 */
export const getReferralCookie = (): string | null => {
  return getCookie(REFERRAL_COOKIE_NAME);
};

/**
 * Clear referral code cookie
 */
export const clearReferralCookie = (): void => {
  clearCookie(REFERRAL_COOKIE_NAME);
};